module.exports = __webpack_public_path__ + "img/addcomp_btn.cde1e872.svg";